import { config } from "../../../shared/config";
import { QuestionID, QuestionKey } from "../types/step-three-types";

export const questionIDs = [
    config.questionIds.employmentType,
    config.questionIds.workplace,
    config.questionIds.shift,
    config.questionIds.salary,
  ] as const;
  
  export const questionKeys = [
    "employmentType",
    "workplace",
    "shift",
    "salary",
  ] as const;
  
  export const formThreeQuestionsIdMapping: Record<QuestionID, QuestionKey> = {
    [`${config.questionIds.employmentType}`]: "employmentType",
    [`${config.questionIds.workplace}`]: "workplace",
    [`${config.questionIds.shift}`]: "shift",
    [`${config.questionIds.salary}`]: "salary",
  };
  
  export const STEP_THREE_INITIAL_VALUES = {
    employmentType: [""],
    workplace: [""],
    shift: [""],
    salary: [""],
  };
  
  export const MAX_SALARY = "999999";